<template>
    <v-container fluid>

        <v-row class="pl-4 pr-4">

            <!-- Column with DISTRIBUTOR address -->
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <div
                            class="read-only-caption"
                            :alvqa="alvqa + '-caption-adresse'"
                        >{{ $t('lang_GENERIC_AZ_CAPTION_ADDRESS') }}:
                            <BaseIcon   
                                :alvqa="alvqa + '-icon-address-copy-to-clipboard'"
                                :small="true"
                                icon="content_copy" 
                                color="buttonStandard"
                                @click.stop="copyToClipboard($alvPlugin.getAddressInternational(item))"
                            />
                        </div>
                        <span :alvqa="alvqa + '-address'" 
                            v-html="$alvPlugin.getAddressInternational(item)">
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Column with FULL SHIPPING ADDRESS: don't ask why just != null does not work here -->
            <v-col v-if="item.fullShippingAddress != '' && item.fullShippingAddress != null">
                <v-card elevation="0">
                    <v-card-text>
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-full-shipping-address'"
                            >{{ $t('lang_AZ_GROUPS_CAPTION_SHIPPING_ADDRESS') }}:</div>
                            <div v-html="item.fullShippingAddress" :alvqa="alvqa + '-full-shipping-address'"></div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Column with Types and contact numbers -->
            <v-col>
                <v-card elevation="0">
                    <v-card-text>

                        <!-- ALVID -->
                        <span v-if="item.alvId != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-alvid'"
                            >{{ $t('lang_GENERIC_CAPTION_ALVID') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-alvid'"
                            >{{ item.alvId }}</div>
                        </span>

                        <!-- TYPE -->
                        <span v-if="item.type != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-type'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_TYPE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-type'"
                            >{{ $alvPlugin.getAzTypes(item.type) }}</div>
                        </span>

                        <!-- EMAIL -->
                        <span v-if="item.email != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-email'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_EMAIL') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-email'"
                            >{{ item.email }}</div>
                        </span>

                        <!-- PHONE -->
                        <span v-if="item.phone != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-phone'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_PHONE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-phone'"
                            >{{ item.phone }}</div>
                        </span>

                        <!-- FAX -->
                        <span v-if="item.fax != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-fax'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_FAX') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-fax'"
                            >{{ item.fax }}</div>
                        </span>

                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Column with Metadata -->
            <v-col>
                <v-card elevation="0">
                    <v-card-text>

                        <!-- LANGUAGE -->
                        <span v-if="item.metadata.language != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-metadata-language'"
                            >{{ $t('lang_GENERIC_CAPTION_LANGUAGE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-metadata-language'"
                            >{{ $alvPlugin.getTranslatedLanguageName(item.metadata.language) }}</div>
                        </span>

                        <!-- CURRENCY -->
                        <span v-if="item.metadata.distributorCurrency != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-metadata-distributor-currency'"
                            >{{ $t('lang_GENERIC_CAPTION_CURRENCY') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-metadata-distributor-currency'"
                            >{{ item.metadata.distributorCurrency }}</div>
                        </span>

                        <!-- SALES COUNTRY aka to which COUNTRY sales to this entity are assigned -->
                        <span v-if="item.salesCountry != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-sales-country'"
                            >{{ $t('lang_AZ_DISTRIBUTORS_CAPTION_SALES_COUNTRY') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-sales-country'"
                            >{{ getCountry(item.salesCountry) }}</div>
                        </span>

                        <!-- RETURN FEE -->
                        <span v-if="item.metadata.distributorReturnFee != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-metadata-distributor-return-fee'"
                            >{{ $t('lang_AZ_DISTRIBUTORS_CAPTION_RETURNS_FEE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-metadata-distributor-return-fee'"
                            >{{ item.metadata.distributorReturnFee }}</div>
                        </span>

                        <!-- RETURN RESERVE CYCLE -->
                        <span v-if="item.metadata.distributorReturnReserveCycle != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-metadata-distributor-return-reserve-cycle'"
                            >{{ $t('lang_AZ_DISTRIBUTORS_CAPTION_RETURNS_RESERVE_CYCLE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-metadata-distributor-return-reserve-cycle'"
                            >{{ $t(getCycle(item.metadata.distributorReturnReserveCycle)) }}</div>
                        </span>

                        <!-- RETURN RESERVE PERCENT -->
                        <span v-if="item.metadata.distributorReturnReservePercent != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-metadata-distributor-return-reserve-percent'"
                            >{{ $t('lang_AZ_DISTRIBUTORS_CAPTION_RETURNS_RESERVE_PERCENT') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-metadata-distributor-return-reserve-percent'"
                            >{{ item.metadata.distributorReturnReservePercent }}</div>
                        </span>

                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Column with Finance data -->
            <v-col v-if="showFinanceDataColumn(item)">
                <v-card elevation="0">
                    <v-card-text>

                        <!-- PAYMENT TARGET -->
                        <span v-if="item.finance.paymentTarget != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-finance-payment-target'"
                            >{{ $t('lang_GENERIC_CAPTION_PAYMENT_TARGET') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-finance-finance-payment-target'"
                            >{{ item.finance.paymentTarget }}</div>
                        </span>

                        <!-- VAT ID -->
                        <span v-if="item.finance.vatId != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-finance-vatid'"
                            >{{ $t('lang_GENERIC_CAPTION_VAT_ID') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-finance-vatid'"
                            >{{ item.finance.vatId }}</div>
                        </span>

                        <!-- PAYMENT ORDER -->
                        <span v-if="item.finance.paymentOrder != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-finance-payment-order'"
                            >{{ $t('lang_GENERIC_CAPTION_PAYMENT_ORDER') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-finance-finance-payment-order'"
                            >{{ item.finance.paymentOrder }}</div>
                        </span>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row class="pl-4 pr-4">
            <v-col v-if="item.notes != null">
                <v-card elevation="0">
                    <v-card-text>

                        <!-- Notes -->
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-notes'"
                            >{{ $t('lang_GENERIC_CAPTION_NOTES') }}:</div>
                            <div
                                :alvqa="alvqa + '-notes'"
                                v-html="showNotesWithBreaks(item.notes)"
                            />
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- Shipment notes -->
            <v-col v-if="item.shippingNote != null">
                <v-card elevation="0">
                    <v-card-text>
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-shipping-notes'"
                            >{{ $t('lang_AZ_DISTRIBUTORS_CAPTION_SHIPMENT_NOTE') }}:</div>
                                <div
                                
                                :alvqa="alvqa + '-shipping-notes'"
                                v-html="showNotesWithBreaks(item.shippingNote)"
                            />
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

        </v-row>

        <!-- METADATA Panel -->
        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat>
                    <AzDistributorsMetadataReadOnlyPanel />
                    <AzDistributorsFinanceReadOnlyPanel />
                </v-expansion-panels>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon'
import { DropdownContractsLabelReturnReserveCycle } from '@/assets/dropdowns/alvDropdowns.js'
import AzDistributorsMetadataReadOnlyPanel from './_panels/AzDistributorsMetadataReadOnlyPanel'
import AzDistributorsFinanceReadOnlyPanel from './_panels/AzDistributorsFinanceReadOnlyPanel'

export default {
    name: "AzDistributorsReadOnly",
    components: {
        AzDistributorsMetadataReadOnlyPanel,
        AzDistributorsFinanceReadOnlyPanel,
        BaseIcon,
    },
    data() {
        return {
            alvqa: 'az-distributors-list-read-only'
        }
    },
    computed: {
        item() { return this.$store.getters.getExpandedAzDistributors[0]
            let item = this.$store.getters.getExpandedAzDistributors.find(element => {
                return element.id === this.itemId
            })

            return item
        },
    },
    methods: {
        getCycle(cycleValue) {
            return DropdownContractsLabelReturnReserveCycle.find(category => {
                return category.value = cycleValue
            }).text
        },
        copyToClipboard(item) {
            let address = item.replace(/<br\s*[\/]?>/gi, "\n")
            navigator.clipboard.writeText(address);
        },
        showNotesWithBreaks(notes) {
            let formatedNotes = notes.replace(/\n/gi,"<br />")
            return formatedNotes
        },
        showFinanceDataColumn(item){
            if(item.finance.paymentTarget === null && item.finance.vatId === null && item.finance.paymentOrder === null){
                return false
            }else{
                return true
            }
        },
        getCountry(countryCode) {            
            return this.$alvPlugin.getTranslatedCountryName(countryCode)
        },
    },
    created() {
        this.$store.commit('setLanguages')
        this.$store.commit('setCountries')
    },
}
</script>